export default {
      id: "settingsPhone-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#settingsPhone-usage",
      toString: function () {
        return this.url;
      }
    }